import { Location } from 'features/inventory/locations/types';
import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';

class LocationService extends BaseService<Location> {
  canDelete = true;

  constructor() {
    super('locations');
  }

  assignProduct = async (locationId: number, product: number) => {
    const res = await axiosPrivate.patch(`${this.modulePrefix}/${locationId}/assign_product/`, {
      product
    });
    return res.data;
  };

  removeProduct = async (locationId: number, product: number) => {
    const res = await axiosPrivate.patch(`${this.modulePrefix}/${locationId}/remove_product/`, {
      product
    });
    return res.data;
  };

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const locationService = new LocationService();
